import { Logger } from 'utilities';

/** Strip rich-text HTML to plain text and collapse whitespace. */
export const htmlToPlainText = (html: string): string => {
  if (!html) {
    return '';
  }
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return (doc.body.textContent ?? '').replace(/\u00a0/g, ' ').replace(/\s+\n/g, '\n').trim();
  } catch (error) {
    Logger.warn('ExportWidgetRelay: failed to parse note HTML', error);
    return '';
  }
};
